import Rest from '../Rest'

export default class ContactListService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/contact-list'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  clone(listId: any) {
    return this.post(`/${listId}/clone`)
  }

  addContact(listId: any, model: any) {
    return this.put(`/${listId}/contact`, model)
  }

  removeContact(listId: any, contactId: any) {
    return this.delete(`/${listId}/contact/${contactId}`)
  }
}
